import React, { useState } from "react";
import './MainNav.css'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Button from "@mui/material/Button";
import {useHistory} from "react-router-dom";
import {SiteSelection} from "../SiteSelection/SiteSelection";
import {clearLoginAsSession} from '../../Users/loginAsSession';

export default function MainNav({user, customer}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    setAnchorEl(null);
    localStorage.removeItem('user');
    clearLoginAsSession();
    history.push({pathname: "/login"});
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <nav>
      <ul>
        {customer && <li className={'customer'}><SiteSelection currentSite={customer} user={user}/></li>}
        <li>
          <IconButton aria-describedby={id} onClick={handleClick} size="large">
            <AccountCircleOutlinedIcon />
          </IconButton>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <div className="profile-popover">
              <div className="profile-details">
                <p className="profile-welcome">Welcome</p>
                <p className="profile-name">{user.firstName} {user.lastName}</p>
                <p className="profile-email">{user.email}</p>
              </div>
              <Button onClick={logout}>Sign Out</Button>
            </div>
          </Popover>
        </li>
      </ul>
    </nav>
  );
}
